import React from "react"
import { Helmet } from "react-helmet"

export type NoIndexProps = {
  follow?: boolean
}

export const NoIndex = ({ follow = false }: NoIndexProps) => (
  <Helmet>
    <meta
      name="robots"
      content={follow ? "noindex, follow" : "noindex, nofollow"}
    />
  </Helmet>
)
